import { createUseStyles } from 'react-jss'

const useTabStyle = () => {
  const useStyles = createUseStyles({
    selectedTab: {
      fontWeight: '700 !important',
      borderRadius: '4px !important',
      borderBottom: '4px solid #F15E2A !important',
    },
  })
  const classes = useStyles()
  return { classes }
}

export default useTabStyle
